module.exports = __webpack_public_path__ + "static/media/layer-icon.78c58a6c.svg";